export default {
    CURRENT_THEME: "CURRENT_THEME",
};
